import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-avatar-photo',
  templateUrl: './avatar-photo.component.html'
})
export class AvatarPhotoComponent {

  @Input('base64')
  public base64?: string = '';
  
  @Input('name')
  public name?: string = '';

  private colors: string[] = [];
  
  public initials: string = '';
  public circleColor: string = '';

  /**
   * Generate initiales of the user's name when there's no profile picture.
   * @returns Initials.
   */
  public generateInitials(): string {
    if(!this.name) return '';

    const randomIndex = Math.floor(
      Math.random() * Math.floor(this.colors.length)
    );
    
    this.circleColor = this.colors[randomIndex];
    
    let initials = '';
    
    for (let i = 0; i < this.name.length; i++) {
      if (this.name.charAt(i) === ' ') {
        continue;
      }
      if (this.name.charAt(i) === this.name.charAt(i).toUpperCase()) {
        initials += this.name.charAt(i);

        if (initials.length == 2) {
          break;
        }
      }
    }

    return initials;
  }
}